import React from 'react'
import { serverUrl } from 'utils/config'
import PropTypes from 'prop-types'

export const Flag = ({ src, className, alt, isCrypto }) => {
	return <span className={`c-flag ${className}`}>
		<img src={`${serverUrl}${src}`} alt={alt} className={ isCrypto ? 'u-border-radius--circle' : null} />
	</span>
}

Flag.propTypes = {
	src: PropTypes.string,
	classname: PropTypes.string,
	alt: PropTypes.string,
	isCrypto: PropTypes.bool
}

export default Flag
